<template>
    <van-popup :value="show" round position="bottom" @input="handleClose" class="van-popup">
        <div class="picker" v-if="options">
            <div class="picker-title-wrapper">
                <div class="title">请选择{{ title }}</div>
                <div class="close-btn" @click="handleClose(false)"></div>
            </div>

            <div class="picker-item-list-wrapper">
                <ul class="picker-item-list">
                    <li
                        class="picker-item"
                        v-for="item in options"
                        :key="item.value"
                        :class="{ active: value && item.value === value.value }"
                        @click="handlePick(item)"
                    >
                        <span class="text">{{ item.label }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </van-popup>
</template>

<script>
import VanPopup from 'vant/lib/popup';
import 'vant/lib/popup/style';

export default {
    name: 'PopupPicker',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    components: {
        VanPopup,
    },
    methods: {
        handleTogglePopup(val) {
            this.$emit('input', val);
        },
        handleClose(val) {
            this.$emit('input', val);
        },
        handlePick(item) {
            this.$emit('pick', item);
            if (!this.value || item.value !== this.value.value) {
                this.$emit('change', item);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/blackcard/assets/styles/mixin.scss';
.van-popup {
    background: transparent;
}
.picker {
    width: 7.5rem;
    height: 100%;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem 0.2rem 0rem 0rem;
}

.picker-title-wrapper {
    box-sizing: border-box;
    position: relative;
    padding: 0 0.24rem 0 0.3rem;
    @include border-bottom();
    .title {
        height: 1rem;
        font-size: 0.34rem;
        font-family: PingFang SC;
        color: rgba(51, 51, 51, 1);
        line-height: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .close-btn {
        position: absolute;
        top: 0.3rem;
        right: 0.24rem;
        width: 0.44rem;
        height: 0.44rem;
        background: url('../../images/icon-close-2.png') center center / 0.44rem 0.44rem no-repeat;
    }
}
.picker-item-list-wrapper {
    position: absolute;
    top: 1rem;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: scroll;
}
.picker-item-list {
    padding: 0 0.24rem 0.24rem 0.24rem;
    padding-bottom: 0.24rem;
    padding-bottom: calc(0.24rem + env(safe-area-inset-bottom));
    padding-bottom: calc(0.24rem + constant(safe-area-inset-bottom));
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
}
.picker-item {
    // display: inline-flex;
    // align-items: center;
    // justify-content: center;
    flex: 0 0 auto;
    box-sizing: border-box;
    width: 3.39rem;
    height: 0.7rem;
    padding: 0 0.1rem;
    margin: 0.24rem 0 0 0;
    border-radius: 0.1rem;
    background: rgba(242, 242, 242, 1);
    color: rgba(51, 51, 51, 1);
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 0.7rem;
    text-align: center;
    &.active {
        background: rgba(255, 252, 245, 1);
        color: rgba(108, 61, 5, 1);
        @include border-1px(rgba(218, 180, 118, 1), 0.2rem);
    }
    .text {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
